import { Box, Divider, Typography } from "@mui/material";
import { HourglassLow } from "phosphor-react";
import React, { useEffect, useState } from "react";
import commonStyles from "../../../../Utils/commonStyles";

const ProjectDeadlineCountdown = ({ completionDate }) => {
  const commonClasses = commonStyles();
  const [time, setTime] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const targetDate = new Date(completionDate);

    const updateCountdown = () => {
      const now = new Date();
      const timeDifference = targetDate - now;

      if (timeDifference <= 0) {
        clearInterval(interval);
        setTime({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
      const seconds = Math.floor((timeDifference / 1000) % 60);

      setTime({ days, hours, minutes, seconds });
    };

    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [completionDate]);

  return (
    <Box className={commonClasses.smallWidgetRoot}>
      <Box className={commonClasses?.widgetTitleContainer}>
        <Box className={commonClasses.flexAndGap8Px}>
          <HourglassLow
            fill="#54E9B5"
            weight="fill"
            color="#54E9B5"
            size={22}
          />
          <Typography className={commonClasses?.widgetsTitle}>
            Countdown
          </Typography>
        </Box>
        {/* <div className={commonClasses.flexAndGap8Px}>
          <PencilLine size={20} color="gray" />
          <Trash size={20} color="gray" />
        </div> */}
      </Box>
      <Box
        sx={{
          backgroundColor: "#1F222E",
          padding: "16px 10px 10px 16px",
          borderRadius: "10px",
          height: "160px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Typography
            sx={{
              color: "#F9F9F9",
              fontWeight: 500,
            }}
          >
            {new Date(completionDate) < new Date()
              ? "Deadline Passes"
              : "Deadline"}
          </Typography>
          {completionDate ? (
            <Box
              sx={{
                display: "flex",
                gap: "5px",
                color:
                  new Date(completionDate) < new Date() ? "#FF5959" : "#54E9B5",
                fontSize: {
                  md: "14px !important",
                  lg: "16px !important",
                  xl: "18px !important",
                },
              }}
            >
              <span>
                {new Intl.DateTimeFormat("en-US", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                }).format(new Date(completionDate))}
              </span>
              <span>|</span>
              <span>
                {new Intl.DateTimeFormat("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                }).format(new Date(completionDate))}
              </span>
            </Box>
          ) : (
            <Typography color="#54E9B5">Not Set</Typography>
          )}
        </Box>
        {completionDate ? <Divider sx={{ my: 2, height: "2px" }} /> : ""}

        {completionDate ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              gap: "16px",
              // mt: "4px",
              // margin: "6px",
            }}
          >
            {/* Countdown */}
            {[
              { title: "Days", value: String(time.days).padStart(2, "0") },
              { title: "Hours", value: String(time.hours).padStart(2, "0") },
              {
                title: "Mins Left",
                value: String(time.minutes).padStart(2, "0"),
              },
            ].map((sin) => (
              <Box
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  gap: "4px",
                }}
                key={sin.title}
              >
                <Typography sx={{ fontSize: "40px", fontWeight: 500 }}>
                  {sin.value}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: "#ECECECCC",
                    mb: "8px",
                  }}
                >
                  {sin.title}
                </Typography>
              </Box>
            ))}
          </Box>
        ) : (
          <Typography color="#606479" mt={1}>
            Set Project deadline in Project settings to view the countdown here.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ProjectDeadlineCountdown;
